import {Injectable} from "@angular/core";
import {ApiService} from "../../../services/api.service";

@Injectable()
export class ForgotUsernameService {

  contextApi = '/api';

  constructor(private apiService: ApiService) {
  }

  public forgotUsernameEmail(
    email: string,
  ): any {
    return this.apiService.putCall(
      this.contextApi + '/public/users/forgot-username/email',
      {
        email: email
      },
      false,
      true,
      true
    )
  }

  public forgotUsernameByPhoneNumberAndLastName(
    phoneNumber: string,
    lastName: string
  ): any {
    return this.apiService.putCall(
      this.contextApi + '/public/users/forgot-username/phone-number-last-name',
      {
        phoneNumber: phoneNumber,
        lastName: lastName
      },
      false,
      false,
      true
    )
  }
}
